@if (show() === true) {
<div class="cookie-banner-backdrop"></div>
<section class="cookie-banner" [class.cookie-banner--top]="position() === 'top'"
    [class.cookie-banner--bottom]="position() === 'bottom'" role="alertdialog"
    aria-label=" הודעת עוגיות ומדיניות פרטיות" aria-modal="true" aria-describedby="idd" tabindex="-1" dir="rtl"
    #bannerElement>
    <div class="cookie-banner__inner">
        <div id="idd" class="cookie-banner__content">
            <span class="cookie-banner__text">
                לידיעתך, אנו משתמשים בקבצי cookies לשיפור חווית הגלישה וניתוח תעבורה והכל בהתאם למדיניות הפרטיות
                המעודכנת. המשך שימוש באתר מהווה הסכמה
            </span>
            <div class="cookie-banner__link-group">
                <a class="cookie-banner__link" href='https://www.tel-aviv.gov.il/About/Pages/TermsofService.aspx'
                    target='_blank'>לתנאי השימוש</a>
                <a class="cookie-banner__link cookie-banner__link--spaced"
                    href='https://www.tel-aviv.gov.il/About/Pages/PrivacyStatement.aspx' target='_blank'>ולמדיניות
                    הפרטיות</a>
                <button type="button" class="cookie-banner__btn cookie-banner__btn--inline" (click)="onAccept()">
                    הבנתי
                </button>
            </div>
        </div>

        <div class="cookie-banner__actions">
            <button type="button" class="cookie-banner__btn" (click)="onAccept()">
                הבנתי
            </button>
        </div>
    </div>

</section>
}